(() => {
  function setup(root) {
    if (root.dataset.publicZoomReady) return;
    const dialog = root.parentElement.querySelector('[data-eclat-zoom-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    root.dataset.publicZoomReady = 'true';
    const isGallery = root.hasAttribute('data-clairatier-home-gallery');
    const hero = root.querySelector('[data-eclat-hero-sticker]');
    const content = dialog.querySelector('[data-eclat-zoom-content]');
    const close = dialog.querySelector('[data-eclat-zoom-close]');
    // Repair the inherited preview watermark encoding without changing native artwork files.
    root.querySelectorAll('svg text').forEach(text => {
      if (text.textContent === 'Â© CLAIRATIER â€¢ PREVIEW') text.textContent = '© CLAIRATIER';
    });
    let opener;
    let serial = 0;
    function open(trigger) {
      const original = isGallery ? trigger.querySelector('img') : hero?.querySelector('.eclat-sticker');
      if (!original) return;
      opener = trigger;
      const copy = original.cloneNode(true);
      if (isGallery) {
        copy.src = trigger.dataset.zoomSrc || original.src;
        copy.loading = 'eager';
      }
      const ids = new Map();
      copy.querySelectorAll('[id]').forEach(element => {
        const id = element.id;
        const next = 'public-zoom-' + (++serial) + '-' + id;
        ids.set(id, next);
        element.id = next;
      });
      [copy, ...copy.querySelectorAll('*')].forEach(element => {
        for (const attribute of [...element.attributes]) {
          if (attribute.name.startsWith('data-eclat-')) element.removeAttribute(attribute.name);
          else {
            let value = attribute.value;
            for (const [id, next] of ids) {
              value = value.replaceAll('url(#' + id + ')', 'url(#' + next + ')');
              if (value === '#' + id) value = '#' + next;
            }
            if (value !== attribute.value) element.setAttribute(attribute.name, value);
          }
        }
      });
      copy.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
      // A first model selection can open the zoom before its raster has loaded.
      // The detached clone must switch to the reviewed layout when its own image arrives.
      const layoutPreview = copy.querySelector('.eclat-sticker__layout-preview');
      if (layoutPreview?.getAttribute('src')) {
        const revealLayout = () => copy.classList.toggle('eclat-sticker--approved-layout', layoutPreview.naturalWidth > 0);
        layoutPreview.addEventListener('load', revealLayout, {once:true});
        layoutPreview.addEventListener('error', () => copy.classList.remove('eclat-sticker--approved-layout'), {once:true});
        if (layoutPreview.complete) revealLayout();
      }
      dialog.dataset.eclatFadeEnabled = root.dataset.eclatFadeEnabled || 'false';
      content.replaceChildren(copy);
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('cp-zoom-open');
      close.focus();
    }
    function enablePreview(element) {
      if (!element || element.dataset.publicZoomTrigger) return;
      element.dataset.publicZoomTrigger = 'true';
      element.setAttribute('role', 'button');
      element.setAttribute('tabindex', '0');
      element.setAttribute('aria-haspopup', 'dialog');
      element.setAttribute('aria-label', dialog.dataset.zoomOpenLabel);
      element.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault(); open(element);
        }
      });
    }
    enablePreview(hero);
    enablePreview(root.querySelector('[data-eclat-mini] .eclat-sticker'));
    if (hero) {
      const observer = new MutationObserver(() => enablePreview(root.querySelector('[data-eclat-mini] .eclat-sticker')));
      observer.observe(root, {childList: true, subtree: true});
    }
    root.addEventListener('click', event => {
      const trigger = event.target.closest('[data-eclat-model], [data-eclat-character-choice], [data-public-zoom-trigger]');
      if (!trigger || !root.contains(trigger)) return;
      // Native selection handlers run first; copy the actual sticker after their update.
      requestAnimationFrame(() => open(trigger));
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('cp-zoom-open');
      content.replaceChildren();
      opener?.focus({preventScroll: true});
    });
  }
  function init(scope = document) { scope.querySelectorAll('[data-clairabord-eclat], [data-clairatier-home-gallery]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
